var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.559,
    height: 15.437,
    viewBox: "0 0 20.559 15.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "promotion") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-promotion-2113956",
    transform: "translate(-116.664 -92.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M136.2,107.339a1.03,1.03,0,0,1-.4-.082l-8.851-3.783a3.082,3.082,0,0,0-1.182-.247h-8.069a1.028,1.028,0,0,1-1.028-1.028V98.088a1.028,1.028,0,0,1,1.028-1.028h8.069a3.085,3.085,0,0,0,1.182-.247l8.809-3.783a1.028,1.028,0,0,1,1.47.946v12.335a1.028,1.028,0,0,1-1.028,1.028Zm-17.475-6.168h7.042a5.141,5.141,0,0,1,2.056.411l7.35,3.166V95.5L127.787,98.7a5.139,5.139,0,0,1-2.056.411h-7.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M234.362,197.972a1.028,1.028,0,0,1-1.028-1.028v-9.251a1.028,1.028,0,0,1,2.056,0v9.251a1.028,1.028,0,0,1-1.028,1.028Z",
    transform: "translate(-111.53 -89.605)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.2b037fbfb1525f26388e5f29ca0443b7.svg";
export { ForwardRef as ReactComponent };